// VIDEO LAZYLOAD
document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

$(document).on("click", "[add-to-cart-express]", function (event) {
  event.preventDefault();
  let formData = {
    items: [
      {
        id: parseInt($(this).attr("add-to-cart-express")),
        quantity: 1,
      },
    ],
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      document.dispatchEvent(
        new CustomEvent("cart-update", {
          detail: { ...response, eventName: "add_to_cart" },
        })
      );
      window.updateCart();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});
// UPSELL Carrinho
window.upsellSliderInit = function () {
  var upsellCartSlider = new Swiper(".recommend-slider", {
    slidesPerView: "auto",
    spaceBetween: 15,
    slidesPerGroup: 3,
    freeMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
  });
};

function beforeSend() {
  $("#dropdown-cart").addClass("updating-cart");
}

function afterSend() {
  $("#dropdown-cart").removeClass("updating-cart");
}

$(document).on("submit", ".upsell-form", function (e) {
  e.preventDefault();

  const formData = new FormData(this);
  const serializedData = {};
  formData.forEach((value, key) => {
    serializedData[key] = value;
  });
  const jsonData = JSON.stringify(serializedData);

  // URL da API da Shopify para adicionar um item ao carrinho
  const addToCartUrl = window.Shopify.routes.root + "cart/add.js";

  // Opções da requisição
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: jsonData,
  };

  beforeSend(); // Ação "before send" antes da requisição

  // Faz a requisição usando fetch com ação "before send" e "after send"
  fetch(addToCartUrl, requestOptions)
    .then((response) => {
      afterSend(); // Ação "after send" após a conclusão da requisição

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      // A requisição foi bem-sucedida, você pode atualizar o carrinho ou fazer outras ações necessárias aqui
      document.dispatchEvent(
        new CustomEvent("cart-update", {
          detail: { ...data, eventName: "add_to_cart" },
        })
      );
      window.updateCart();
    })
    .catch((error) => {
      // Houve um erro na requisição, você pode tratar o erro aqui
      console.error("Error:", error);
    });
});

$(document).on("input", "#custom-property", function (e) {
  document.querySelector("#meta_customization").value = e.target.value;
  const btn = document.querySelector("[data-btn-addToCart]");

  if (e.target.value?.length > 0) {
    btn.disabled = false;
  } else {
    btn.disabled = true;
  }
});

/* CORRECAO: seletor de cor do painel fixo (CTA) mobile.
   Defeito do tema Halo: (1) <variant-sticky-radios> nao liga ouvinte de clique;
   (2) o form proprio do painel mobile nunca sincroniza o input[name=id] com a cor,
   entao ia a variante inicial ao carrinho. Correcao idempotente, sem libs. */
(function () {
  function moneyBRL(cents) {
    try {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(cents / 100);
    } catch (e) { return null; }
  }
  function wire(el) {
    if (el.dataset.fixMobileWired === "1") return;
    el.dataset.fixMobileWired = "1";
    var panel = el.closest(".sticky-product-mobile") || el.closest("sticky-add-to-cart") || document;
    var jsonNode = el.querySelector('script[type="application/json"]');
    if (!jsonNode) return;
    var variants;
    try { variants = JSON.parse(jsonNode.textContent); } catch (e) { return; }
    var radios = el.querySelectorAll("input.product-form__radio.mobile");
    if (!radios.length) return;
    function optionNames() {
      var names = [];
      el.querySelectorAll("fieldset[data-option-index]").forEach(function (fs) {
        var idx = parseInt(fs.getAttribute("data-option-index"), 10);
        var checked = fs.querySelector("input.product-form__radio.mobile:checked");
        names[idx] = checked ? checked.value : null;
      });
      return names;
    }
    function findVariant() {
      var selected = optionNames();
      var anyChecked = el.querySelector("input.product-form__radio.mobile:checked");
      if (selected.filter(Boolean).length <= 1 && anyChecked && anyChecked.dataset.variantId) {
        var byId = variants.find(function (v) { return String(v.id) === String(anyChecked.dataset.variantId); });
        if (byId) return byId;
      }
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] == null || selected[i] === opt; });
      });
    }
    function sync() {
      var v = findVariant();
      if (!v) return;
      panel.querySelectorAll('input[name="id"]').forEach(function (inp) { inp.value = v.id; });
      var priceNode = panel.querySelector(".sticky-price .money-subtotal");
      if (priceNode) { var m = moneyBRL(v.price); if (m) priceNode.textContent = m; }
      var cmpWrap = panel.querySelector(".sticky-price");
      var cmpNode = panel.querySelector(".sticky-price .money-compare-price");
      if (cmpNode) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var mc = moneyBRL(v.compare_at_price); if (mc) cmpNode.textContent = mc;
          if (cmpWrap) cmpWrap.classList.add("has-compare-price");
        } else {
          cmpNode.textContent = "";
          if (cmpWrap) cmpWrap.classList.remove("has-compare-price");
        }
      }
      el.querySelectorAll("fieldset[data-option-index]").forEach(function (fs) {
        var checked = fs.querySelector("input.product-form__radio.mobile:checked");
        var header = fs.querySelector("[data-header-option]");
        if (checked && header) header.textContent = checked.value;
      });
    }
    el.addEventListener("change", function (e) {
      if (e.target && e.target.classList && e.target.classList.contains("product-form__radio")) { sync(); }
    });
    el.addEventListener("click", function (e) {
      var lbl = e.target.closest && e.target.closest("label.product-form__label.mobile");
      if (lbl) { setTimeout(sync, 0); }
    });
    sync();
  }
  function init() { document.querySelectorAll("variant-sticky-radios").forEach(wire); }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); } else { init(); }
  document.addEventListener("shopify:section:load", init);
})();
/* CORRECAO: grade das colecoes com o app EX Show Variants (Variator, Extendons).
   Defeito do app: ele insere TODOS os cartoes de variante dentro de UMA unica
   celula da grade, em vez de uma celula por variante. Resultado: os cartoes
   empilham numa coluna so e o resto da linha fica vazio.
   Esta correcao move cada cartao extra para uma celula propria, clonada da
   celula que o proprio tema criou, preservando largura, espacamento e ordem.
   Vale para qualquer colecao, busca, paginacao e rolagem infinita.
   Idempotente, sem libs. Adicionada em 07/08/2026.
   Pode ser removida quando a Extendons corrigir o app. */
(function () {
  function ajustar() {
    var cartoes = document.querySelectorAll(".eosh-rendered");
    if (!cartoes.length) return false;

    var celulas = [];
    for (var i = 0; i < cartoes.length; i++) {
      var pai = cartoes[i].parentElement;
      if (pai && pai.parentElement && celulas.indexOf(pai) === -1) celulas.push(pai);
    }

    var mexeu = false;
    for (var j = 0; j < celulas.length; j++) {
      var celula = celulas[j];
      var dentro = [];
      for (var k = 0; k < celula.children.length; k++) {
        if (celula.children[k].classList.contains("eosh-rendered")) {
          dentro.push(celula.children[k]);
        }
      }
      if (dentro.length < 2) continue;

      var ref = celula;
      for (var m = 1; m < dentro.length; m++) {
        var nova = celula.cloneNode(false);
        nova.setAttribute("data-eosh-celula-extra", "1");
        nova.appendChild(dentro[m]);
        ref.parentElement.insertBefore(nova, ref.nextSibling);
        ref = nova;
        mexeu = true;
      }
    }
    return mexeu;
  }

  var agendado = null;
  function agendar() {
    if (agendado) return;
    agendado = setTimeout(function () {
      agendado = null;
      ajustar();
    }, 120);
  }

  function iniciar() {
    ajustar();
    if (!("MutationObserver" in window)) return;
    new MutationObserver(agendar).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else {
    iniciar();
  }
  document.addEventListener("shopify:section:load", agendar);
})();

